
import { useEffect } from 'react'
import { Form, Input, Result } from 'antd'
import { useAppSelector } from '../../../store/hooks'
import { selectSelectedSegment } from '../../../store/SegmentReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'

const Delete = ({ form }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedSegment())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form form={form} layout="vertical">
      <Result
        title={'Are you sure ?'}
        subTitle={
          'Deleting this resource will also delete all resource associated. This action is immediate and cannot be undone.'
        }
      />
      <Form.Item name="id" hidden required rules={[]} className="d-none">
        <Input type="hidden" />
      </Form.Item>
    </Form>
  )
}

export default Delete
